// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1YQxM","title":"FrontImage_title__nqcg0"};